import React from 'react';
import { useTranslation } from 'react-i18next';
import { OpenAccountButton } from '../ui/OpenAccountButton';
import styles from './HeroSection.module.css';

export const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.hero}>
      <div className={styles.heroImageContainer}>
        <img 
          src="/banking2.png" 
          alt="Global Chic Business Banking Services" 
          className={styles.heroImage}
        />
        <div className={styles.heroOverlay}>
          <h1 className={styles.title}>{t('home.hero.title')}</h1>
          <div className={styles.buttonContainer}>
            <OpenAccountButton 
              className={styles.ctaButton}
              variant="primary"
              size="large"
            />
          </div>
          <h2 className={styles.subtitle}>{t('home.hero.subtitle')}</h2>
        </div>
      </div>
      <div className={styles.requirementsSection}>
        <div className={styles.infoSection}>
          <h3 className={styles.infoTitle}>{t('home.hero.requirementsTitle')}</h3>
          <ul className={styles.requirementsList}>
            <li>{t('home.hero.requirement1')}</li>
            <li>{t('home.hero.requirement2')}</li>
            <li>{t('home.hero.requirement3')}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

